import { ChooseFrequencyLaterSteps_OfferLockDataFragment } from './__generated__/choose-frequency-later-steps.graphql'

export enum ChooseFrequencyLaterModalSteps {
  SELECT_OFFER = 'selectOffer',
  SELECT_FREQUENCY = 'selectFrequency',
}

export enum StepButtonLabels {
  SELECT_OFFER = 'Escolher plano',
  CONFIRM = 'Confirmar assinatura',
  BACK = 'Voltar',
}

export type ChooseFrequencyLaterModalStepsType = `${ChooseFrequencyLaterModalSteps}`

export type ChooseFrequencyLaterPlanOffer =
  ChooseFrequencyLaterSteps_OfferLockDataFragment['body']['cards'][number]

export interface ChooseFrequencyLaterContextProviderValues {
  isPaywall: boolean
  hasYearlyOffers: boolean
  hasMonthlyOffers: boolean
  isCompactModal: boolean
  compactHeader: boolean
  currentStep: ChooseFrequencyLaterModalStepsType
  selectedPlanOffers: ChooseFrequencyLaterPlanOffer[]
  selectedFrequencyOffer: ChooseFrequencyLaterPlanOffer | null
  handleSelectPlan: (offerTitle: string) => void
  handleSelectFrequencyOffer: (selectedOffer: ChooseFrequencyLaterPlanOffer | null) => void
  backToSelectOffer: () => void
}
